import React from 'react';
import { BsGithub,BsInstagram } from 'react-icons/bs';

import { BiLogoWhatsapp } from 'react-icons/bi';
import { AiFillLinkedin } from 'react-icons/ai'

const SocialMedia = () => (
  <div className="app__social">
      
    <div>
    <a  href='https://www.instagram.com/_jeffry_____/'>
       <BsInstagram />
    </a>
   
    </div>
    {/* <div>
      <a  href='https://www.facebook.com/profile.php?id=100093130425780'>
        <FaFacebookF />
      </a>
  
    </div> */}
    <div>
    <a href='https://github.com/salmanpoomonmlp'>
                  <BsGithub />
                </a>
    </div>
    {/* <div>
    <a href='https://wa.link/5yyril'>
                  <BiLogoWhatsapp  />
                </a>
    </div> */}
    <div>
      <a href='www.linkedin.com/in/salman-faris-3917ba28b'>
        <AiFillLinkedin/>
      </a>
    </div>
    {/* <a href='https://www.instagram.com/salman____faris.___/' id='ix94i-2'>
                  <BsInstagram className='link-img' alt='Instagram' />
                </a>
                <a href='https://www.facebook.com/profile.php?id=100093130425780'>
                  <BsFacebook className='link-img' alt='Facebook' />
                </a>
                <a href='https://github.com/salmanpoomonmlp'>
                  <BsGithub className='link-img' alt='Github' />
                </a>
                <a href='https://wa.link/5yyril'>
                  <BiLogoWhatsapp className='link-img' alt='Github' />
                </a> */}
  </div>
);

export default SocialMedia;